import {ChangeDetectorRef, Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {DrawerComponent, DrawerSelectEvent} from "@progress/kendo-angular-layout";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {DialogService, WindowService} from "@progress/kendo-angular-dialog";
import {SessionService} from "../../core/services/session.service";
import {BroadcasterService} from "../../core/broadcaster.service";
import {showNotification} from "../../shared/utilities/notificaton.util";
import {NotificationService} from "@progress/kendo-angular-notification";

@Component({
    selector: 'app-smart-de',
    templateUrl: './smart-de.component.html',
    styleUrls: ['./smart-de.component.scss'],
    standalone: false
})
export class SmartDeComponent implements OnInit{
  @ViewChild('drawer') drawer: DrawerComponent | undefined;
  public value: any;
  public drawerOpen = false;
  constructor(private router: Router, private broadcaster: BroadcasterService,
              private sessionService: SessionService, private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.broadcaster.on('toggle').subscribe(() => {
      this.drawerOpen = !this.drawerOpen;
    });
  }


  public toggleDrawer() {
    this.drawerOpen = !this.drawerOpen;
  }

  navigate(route) {
    this.router.navigate([route]);
  }

  logout() {
    this.sessionService.logout().subscribe(r => {});
    this.router.navigate(['/']);
    showNotification('You have been logged out', 'info', this.notificationService);
  }
}
